import $ from 'jquery';

document.addEventListener('DOMContentLoaded', ()=>{

    let copyButtons = document.querySelectorAll('.jsCopyButton');

    for (let index = 0; index < copyButtons.length; index++) {
        const item = copyButtons[index];
        let link = document.location.href;
        item.setAttribute('href', link);
        item.querySelector('span.button__text').innerHTML = link;

    }
})

$('.jsCopyButton').on('click', function(e){
    var isiOSDevice = navigator.userAgent.match(/ipad|iphone/i);
    e.preventDefault();

    var $this = $(this);
    var $temp = $("<input>", {
        class: 'copy-to-clipboard-input',
        id: 'copy-to-clipboard-input',
        readonly: true,
        value: $this.attr('href')
    });

    $this.append($temp);
    var input = document.getElementById('copy-to-clipboard-input');
    if (isiOSDevice) {
        var editable = input.contentEditable;
        var readOnly = input.readOnly;

        input.contentEditable = true;
        input.readOnly = false;

        var range = document.createRange();
        range.selectNodeContents(input);

        var selection = window.getSelection();

        selection.removeAllRanges();
        selection.addRange(range);

        input.setSelectionRange(0, 999999);
        input.contentEditable = editable;
        input.readOnly = readOnly;
    } else {
        $temp.select();
    }
    document.execCommand("copy");
    $temp.remove();
    toggleClasses()
    function toggleClasses(){
        $this.addClass('is-active')

        setTimeout(() => {
            $this.removeClass('is-active')
        }, 1000);
    }
})